"use client";

import {
	PanelResizer,
	useLeftPanelWidth,
} from "@saas/ai-image-generator/components/PanelResizer";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";
import { ImageEffectFeed } from "./ImageEffectFeed";
import { ImageEffectHeading } from "./ImageEffectHeading";

export function ImageEffectWorkbench({
	href,
	description,
	children,
	action,
	preview,
}: {
	href: string;
	description: string;
	children: ReactNode;
	action: ReactNode;
	preview: ReactNode;
}) {
	const t = useTranslations("aiImageGenerator.client");
	const { width, commit } = useLeftPanelWidth();
	return (
		<div
			id="image-effect-workbench"
			className="studio-theme w-full py-2 sm:px-4 studio-split:-mx-8 studio-split:-mt-8 studio-split:w-auto studio-split:p-0"
		>
			<div className="flex flex-col studio-split:h-[calc(100dvh-var(--language-banner-height,0px))] studio-split:min-h-[560px] studio-split:flex-row studio-split:overflow-hidden">
				<aside className="flex min-h-0 w-full shrink-0 flex-col bg-background studio-split:w-[var(--left-panel-w,412px)] studio-split:max-w-[calc(100%-280px)]">
					<div className="min-h-0 flex-1 space-y-7 pb-6 studio-split:overflow-y-auto studio-split:p-4">
						<header>
							<ImageEffectHeading href={href} />
							<p className="mt-3 text-sm leading-relaxed text-muted-foreground">
								{description}
							</p>
						</header>
						{children}
					</div>
					<div className="h-20 sm:hidden" aria-hidden />
					<div className="z-30 shrink-0 bg-background py-3 max-sm:fixed max-sm:inset-x-0 max-sm:bottom-0 max-sm:border-t max-sm:px-4 max-sm:pb-[max(12px,env(safe-area-inset-bottom))] studio-split:p-4">
						{action}
					</div>
				</aside>
				<PanelResizer
					width={width}
					onCommit={commit}
					label={t("resizePanels")}
				/>
				<main className="flex min-h-[440px] min-w-0 flex-1 flex-col bg-zinc-100 studio-split:min-h-0 studio-split:overflow-hidden">
					<ImageEffectFeed preview={preview} />
				</main>
			</div>
		</div>
	);
}
